import {tracking as barkTrackingLogEvent} from "@bark/bark-core";

export default function GroupRadioFilter(){

	const { Handlebars } = window;

    const hbTemplate = Handlebars.compile(document.getElementById('group-radio-filter-template').innerHTML);

    const getHtml = (data) => {
        return hbTemplate(data);
    };

    const registerListner = (eventEmitter, filterKey, group) => {
		$(`input[type=radio][name=${filterKey}]`).off('change').on('change', function (e) {
            setChecked($(this), filterKey);
			eventEmitter.emit('filters.mobile.changed', {filter: filterKey, group: group});

            barkTrackingLogEvent(
                'seller-list-&-profile',
                'seller_list_filters - Filter applied',
                {project_id: getProjectHash(), filter_name: filterKey, filter_value: getSelectedValue(filterKey)}
            );

		});
    };

    const getSelectedValue = (filterKey) => {
    	return $(`input[type=radio][name=${filterKey}]:checked`).val();
    };

    const disableFilter = (filterKey) => {
    	$(`input[type=radio][name=${filterKey}]`).attr('disabled', true);
        $(`.group-radio-${filterKey}`).addClass("disabled");
    };

    const enableFilter = (filterKey) => {
    	$(`input[type=radio][name=${filterKey}]`).attr('disabled', false);
    };

    const initFilter = (filterKey) => {
        let selectedOption = $(`input[type=radio][name=${filterKey}]:checked`);
        if(!selectedOption.length){
            selectedOption = $(`input[type=radio][name=${filterKey}][data-is-default-selected="true"]`);
            selectedOption.attr('checked', true);
            setChecked(selectedOption, filterKey);
        }
    };

    const setChecked = ($option, filterKey) => {
        $(`.group-radio-${filterKey}`).removeClass("is-checked");
        $option.parent('label').addClass('is-checked');
    };

    const getProjectHash = () => {
        return $('#project-id').val();
    };

    return {
        getHtml,
        registerListner,
        getSelectedValue,
        disableFilter,
        enableFilter,
        initFilter
    };
}
